import React, { Component } from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import api from "../service/ApiService";
import { baseUrl } from "../service/ApiUrls";
import Loader from "../components/Loader";
import ErrorDialog from "../components/ErrorDialog";

export class DivisionAddEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            name: "",
            description: "",
            isActive: true,
            isLoading: false,
            isError: false,
            errorMessage: "",
            isEdit: false
        };
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.isEdit) {
            const { rowData } = this.props.location.state;
            this.setState({
                isEdit: true,
                id: rowData.id,
                name: rowData.name || "",
                description: rowData.description || "",
                isActive: rowData.isActive !== undefined ? rowData.isActive : true
            });
        }
    }

    onDialogueHide = () => {
        this.setState({ isError: false });
    };

    submitToWeb = () => {
        // Double check just in case
        if (!this.state.name.trim()) return;

        this.setState({ isLoading: true }, () => {
            const dataToSend = {
                name: this.state.name,
                description: this.state.description,
                isActive: this.state.isActive
            };

            if (this.state.isEdit) {
                dataToSend.id = this.state.id;
            }

            const url = this.state.isEdit
                ? `${baseUrl}/division-list/${this.state.id}`
                : `${baseUrl}/division-list/add`;

            const method = this.state.isEdit ? "put" : "post";

            api[method](url, dataToSend)
                .then((res) => {
                    this.setState({ isLoading: false });
                    if (res.data.result.isError === false) {
                        confirmAlert({
                            title: "Success",
                            message: <p className="mod-sp">Division successfully {this.state.isEdit ? "updated" : "created"}!</p>,
                            buttons: [{ label: "Ok", onClick: () => this.props.history.push("/division-management") }]
                        });
                    } else {
                        this.setState({ isError: true, errorMessage: res.data.result.errorMsg });
                    }
                })
                .catch(() => {
                    this.setState({ isLoading: false, isError: true, errorMessage: "Technical connection error." });
                });
        });
    };

    render() {
        const items = [
            { label: "Dashboard", url: "dashboard" },
            { label: "Home Ground", url: "home-ground" },
            { label: "Division Management", url: "division-management" },
            { label: this.state.isEdit ? "Edit Division" : "New Division" },
        ];

        // Logic: Disable if name is empty/whitespace OR if currently loading
        const isSubmitDisabled = !this.state.name.trim() || this.state.isLoading;

        return (
            <div className="p-grid p-fluid" style={{ padding: '1rem' }}>
                <style>{`
                    @media (min-width: 768px) {
                        #updated.p-md-4 {
                            padding: 0.5rem !important;
                        }
                    }
                    /* Visual feedback for disabled state */
                    .p-button:disabled {
                        background: #cbd5e1 !important;
                        cursor: not-allowed !important;
                        opacity: 0.7;
                    }
                `}</style>

                <div className="p-col-12" style={{ marginBottom: '1rem' }}>
                    <BreadCrumb model={items} home={{ icon: "pi pi-home", url: "dashboard" }} style={{ border: 'none', background: 'transparent' }} />
                </div>

                <Dialog visible={this.state.isLoading} modal closable={false} showHeader={false} style={{ width: "20vw" }}>
                    <Loader />
                </Dialog>

                <div className="p-col-12">
                    <div className="card shadow-sm" style={{
                        background: '#ffffff',
                        padding: '2.5rem',
                        borderRadius: '15px',
                        boxShadow: '0 10px 25px rgba(0,0,0,0.05)'
                    }}>
                        <h2 style={{ marginBottom: '2rem', fontWeight: '700', color: '#1e293b', fontSize: '1.5rem' }}>
                            {this.state.isEdit ? "Update Division" : "Create New Division"}
                        </h2>

                        <div className="p-grid">
                            <div className="p-col-12 p-md-8">
                                <label htmlFor="name" style={{ fontWeight: '600', marginBottom: '0.5rem', display: 'block', color: '#475569' }}>
                                    Division Name <span style={{ color: '#ef4444' }}>*</span>
                                </label>
                                <InputText
                                    id="name"
                                    value={this.state.name}
                                    onChange={(e) => this.setState({ name: e.target.value })}
                                    placeholder="Enter division name"
                                    style={{ borderRadius: '8px' }}
                                    className={!this.state.name.trim() ? 'p-invalid' : ''}
                                />
                            </div>

                            <div id="updated" className="p-col-12 p-md-4">
                                <label style={{ fontWeight: '600', marginBottom: '0.5rem', display: 'block', color: '#475569' }}>Status</label>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '38px',
                                    background: '#f8fafc',
                                    borderRadius: '8px',
                                    padding: '0 1rem',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <Checkbox
                                        inputId="activeStatus"
                                        onChange={e => this.setState({ isActive: e.checked })}
                                        checked={this.state.isActive}
                                    />
                                    <label htmlFor="activeStatus" style={{
                                        marginLeft: '0.75rem',
                                        cursor: 'pointer',
                                        fontWeight: '700',
                                        fontSize: '0.85rem',
                                        color: this.state.isActive ? '#16a34a' : '#dc2626'
                                    }}>
                                        {this.state.isActive ? "ACTIVE" : "INACTIVE"}
                                    </label>
                                </div>
                            </div>

                            <div className="p-col-12" style={{ marginTop: '1rem' }}>
                                <label htmlFor="description" style={{ fontWeight: '600', marginBottom: '0.5rem', display: 'block', color: '#475569' }}>Description</label>
                                <InputTextarea
                                    id="description"
                                    rows={4}
                                    value={this.state.description}
                                    onChange={(e) => this.setState({ description: e.target.value })}
                                    placeholder="Briefly describe this division..."
                                    style={{ borderRadius: '8px' }}
                                    autoResize
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '3rem' }}>
                            <Button
                                label={this.state.isEdit ? "Update" : "Submit"}
                                icon={this.state.isLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                                className="p-button-raised p-button-rounded"
                                style={{ background: '#0081C9', border: 'none', width: '160px', fontWeight: '600' }}
                                onClick={this.submitToWeb}
                                disabled={isSubmitDisabled}
                            />
                            <Button
                                label="Cancel"
                                icon="pi pi-times"
                                className="p-button-outlined p-button-rounded p-button-secondary"
                                style={{ width: '160px', fontWeight: '600' }}
                                onClick={() => this.props.history.push("/division-management")}
                            />
                        </div>
                    </div>
                </div>

                <Dialog visible={this.state.isError} modal style={{ width: "25vw" }} onHide={this.onDialogueHide}>
                    <ErrorDialog errorMessage={this.state.errorMessage} />
                </Dialog>
            </div>
        );
    }
}